export default __webpack_public_path__ + "static/media/bgDAD.b18d541c.jpg";